<template>
  <div class="nav-wrapper">
    <div class="experience-container">
    <div class="form-section">
      <div class="business-form">
        <BackButton @back="$emit('back')" />
        <h1 class="main-title">{{ $t('businessExperience.title') }}</h1>
        <div class="experience-options">
          <label class="experience-option" :class="{ 'selected': businessExperience === 'none' }">
            <input type="radio" v-model="businessExperience" value="none" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessExperience.options.none') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessExperience === 'some' }">
            <input type="radio" v-model="businessExperience" value="some" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessExperience.options.some') }}</span>
          </label>

          <label class="experience-option" :class="{ 'selected': businessExperience === 'lots' }">
            <input type="radio" v-model="businessExperience" value="lots" class="radio-input">
            <span class="radio-custom"></span>
            <span class="option-text">{{ $t('businessExperience.options.lots') }}</span>
          </label>
        </div>

        <button class="next-button" @click="handleNext">{{ $t('businessExperience.next') }}</button>
        <button class="skip-button" @click="$emit('skip')">{{ $t('businessExperience.skip') }}</button>
      </div>
    </div>
    <div class="image-section">
      <img src="@/assets/slider2.1.png" alt="Productive workspace with laptop" class="main-image">
    </div>
  </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessExperience',
  components: {
    BackButton
  },
  data() {
    return {
      businessExperience: 'none',
    }
  },
  methods: {
    handleNext() {
      this.$emit('next', {
        businessExperience: this.businessExperience
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 